require('./_wks-define')('asyncIterator');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/es7.symbol.async-iterator.js